// Liste des trajets inter-villes — miroir léger de /app/backend/intercity.py
// Utilisé uniquement pour enregistrer les routes React Router (contenu SEO complet côté API)
// Format URL : /demenagement-{origin}-vers-{destination}

const MATRIX_CITIES = [
  "paris", "lyon", "marseille", "bordeaux", "lille", "toulouse", "nice", "nantes",
  "strasbourg", "rennes", "montpellier", "grenoble", "angers", "dijon", "le-havre",
  "reims", "saint-etienne", "toulon", "aix-en-provence", "brest", "tours", "amiens",
  "limoges", "clermont-ferrand", "metz",
];

const PARIS_ONLY_DESTINATIONS = ["rouen", "orleans", "nancy"];

const SHORT_REGIONAL_TRAJETS = [
  ["paris", "chartres"], ["paris", "versailles"], ["paris", "melun"],
  ["paris", "beauvais"], ["paris", "troyes"],
  ["lyon", "annecy"], ["lyon", "chambery"], ["lyon", "valence"],
  ["marseille", "avignon"], ["marseille", "nimes"], ["marseille", "cannes"],
  ["bordeaux", "la-rochelle"], ["bordeaux", "biarritz"], ["bordeaux", "pau"],
  ["toulouse", "perpignan"], ["toulouse", "albi"],
  ["lille", "calais"], ["lille", "dunkerque"],
  ["nantes", "saint-nazaire"],
  ["rennes", "saint-malo"],
];

const routes = [];
const seen = new Set();

// Matrice 25x25 (600 combinaisons bidirectionnelles)
for (const origin of MATRIX_CITIES) {
  for (const dest of MATRIX_CITIES) {
    if (origin === dest) continue;
    routes.push({ origin, dest });
    seen.add(`${origin}-${dest}`);
  }
}
// Paris → destinations courtes (3 trajets)
for (const dest of PARIS_ONLY_DESTINATIONS) {
  if (seen.has(`paris-${dest}`)) continue;
  routes.push({ origin: "paris", dest });
  seen.add(`paris-${dest}`);
}
// Trajets courts régionaux à sens unique (20 trajets)
for (const [origin, dest] of SHORT_REGIONAL_TRAJETS) {
  if (seen.has(`${origin}-${dest}`)) continue;
  routes.push({ origin, dest });
  seen.add(`${origin}-${dest}`);
}

export const INTERCITY_ROUTES = routes;

export const INTERCITY_SLUGS = routes.map((r) => `/demenagement-${r.origin}-vers-${r.dest}`);

// Anciens slugs (rétrocompatibilité — 15 URLs déjà indexées via l'ancien format)
export const LEGACY_PARIS_SLUGS = [
  "lille", "bordeaux", "lyon", "marseille", "nantes", "toulouse", "strasbourg",
  "rennes", "montpellier", "nice", "rouen", "reims", "orleans", "tours", "nancy",
].map((dest) => `/demenagement-paris-${dest}`);
